export const BASE_TAB_LIST = ['Users', 'Products'];
export const INTERCEPTOR_TAB_LIST = ['Transformations', 'External Auth'];

export const breadcrumbsNav = [
  { title: 'Tenants', link: '/organization' },
  { title: 'Tenants Details', link: '' },
];

export const a11yProps = (index: number) => ({
  id: `scrollable-auto-tab-${index}`,
  'aria-controls': `scrollable-auto-tabpanel-${index}`,
});
